/**
 * AI CONTEXT
 * Purpose: tooltip content for timeline session stripe (headcount/details/attendance summary).
 * Depends on: SessionAttendanceDetails and helper formatters.
 * Used by: SessionStripe.
 * Refactor: move repeated formatting blocks into small presentational pieces.
 */
import { UserOutlined } from "@ant-design/icons"

import Flex from "#blocks/Flex"
import IconBadge from "#blocks/IconBadge"
import { useThemeContext } from "#contexts/ThemeContextProvider"
import { PositionedTimelineSession } from "#customTypes/composedTypes/classSessionTypes"
import { getSessionHeadcount } from "#utils/classHelpers"
import { formatTimeLocale } from "#utils/dateHelpers"
import { camelToWords } from "#utils/textFormatters"

import SessionAttendanceDetails from "./SessionAttendanceDetails"
import TooltipBlock from "./TooltipBlock"

const SessionStripeTooltip = ({
  session,
}: {
  session: PositionedTimelineSession
}) => {
  const theme = useThemeContext()

  const room = camelToWords(session.room)
  const timeString = `${formatTimeLocale(session.eventStart)} - ${formatTimeLocale(session.eventEnd)}`
  const headcount = getSessionHeadcount(session.session)

  return (
    <Flex col gap={8} style={{ padding: "4px 8px", fontSize: 12 }}>
      {session.isInSelectedWindow && (
        <div style={{ color: "#52c41a" }}>✓ Selected</div>
      )}
      <Flex col>
        <h3>{session.name}</h3>
        <IconBadge
          color={theme.white}
          icon={<UserOutlined />}
          text={headcount}
          backgroundColor={theme.highlightYellow}
        />
      </Flex>
      <TooltipBlock title="Details">
        <div>{room}</div>
        <div>{timeString}</div>
      </TooltipBlock>

      <SessionAttendanceDetails session={session} />
    </Flex>
  )
}

export default SessionStripeTooltip
